import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { NvTooltip } from 'shared/components/nv-tooltip';
import { RolePlayInteractionMode } from 'redux/schemas/models/ai-role-play';
import { ROLEPLAY_MODALITIES } from 'roleplay/course-level-management/roleplay-modalities';
import { largeSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';
import { config } from '@config/pendo.config.json';

const tooltipByType: Partial<Record<RolePlayInteractionMode, () => string>> = {
  [RolePlayInteractionMode.TEXT]: () => t.COURSES.DASHBOARD_TABLE.ROLEPLAY_TYPE_TOOLTIP_TEXT(),
  [RolePlayInteractionMode.VOICE]: () => t.COURSES.DASHBOARD_TABLE.ROLEPLAY_TYPE_TOOLTIP_VOICE(),
};

type ApprovedRoleplayTypesCellProps = {
  /** Empty means roleplay is disabled for the course. */
  types?: RolePlayInteractionMode[],
};

const styles = css`
  display: flex;
  align-items: center;
  gap: ${quarterSpacing}px;

  .roleplay-type-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${largeSpacing}px;
    height: ${largeSpacing}px;
    border-radius: 50%;
    pointer-events: all;
  }
`;

const ApprovedRoleplayTypesCell = ({ types }: ApprovedRoleplayTypesCellProps) => {
  const badges = ROLEPLAY_MODALITIES.filter((modality) => types?.includes(modality.type));

  return (
    <div css={styles} data-qa={config.pendo.adminDashboard.approvedRoleplayTypesCell}>
      {badges.length ? badges.map((modality) => {
        const label = tooltipByType[modality.type]?.() ?? modality.label();
        return (
          <NvTooltip key={modality.type} text={label}>
            <span
              className='roleplay-type-badge text-black'
              style={{ background: modality.badgeBackground }}
            >
              <NvIcon icon={modality.icon} size='xss-smallest' altLabel={label} />
            </span>
          </NvTooltip>
        );
      }) : (
        <span className='text-gray-2'>{t.COURSES.DASHBOARD_TABLE.ROLEPLAY_DISABLED()}</span>
      )}
    </div>
  );
};

export default ApprovedRoleplayTypesCell;
